import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { ResponseTrackPolicyDto } from "../dto/policy.dto";

@Injectable()
export class SF6SPolicyApi {

  private service: string = '';
  private model: string = 'sf6s/policy';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public trackPolicy() {

    const method: string = 'GET';
    const func: string = 'trackPolicy';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseTrackPolicyDto[]>>(method, url, params, urlParams, body);
  }

  submitTrackPolicy(formData): Observable<any> {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "submitTrackPolicy";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/sf6s-policy.api.ts